import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useBudgetValidation } from './useBudgetValidation';

import api from '../../../config/api';
import {
  CREATE_BUDGET_PATH
} from '../../../contants';
import { MESSAGE_ERROR } from '../../../contants/messageError';
import {
  changeTab,
  setCurrentStep,
  setUniqueNameError,
} from '../../../features/createBudget/createBudgetSlice';
import { error } from '../../../helpers/notyf';

export const useSetBudgetForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { tab, formData } = useSelector(state => state.createBudget);
  const params = useParams();

  const { validateForm } = useBudgetValidation();

  const checkBudgetName = useCallback(
    async (budgetName, budgetId = null) => {
      const isModeEditBudget = budgetId && !isNaN(budgetId);
      const bodyCheckBudgetName = {
        budgetName: budgetName.trim(),
        ...(isModeEditBudget && { budgetId }),
      };

      try {
        await api.CHECK_BUDGET_NAME(bodyCheckBudgetName);

        dispatch(setCurrentStep(3));

        if (isModeEditBudget) {
          navigate(`/create-budget/campaigns/${budgetId}`);
        } else {
          navigate(`${CREATE_BUDGET_PATH}/campaigns`);
        }

        return { success: true };
      } catch (err) {
        const { response } = err;
        const message = response.data.name[0];

        if (
          message === MESSAGE_ERROR.DUPLICATE_NAME_CLIENT &&
          response.status === 400
        ) {
          dispatch(
            setUniqueNameError('A budget with this name already exists'),
          );
          return { success: false, error: 'DUPLICATE_NAME' };
        } else {
          error(err);
          return { success: false, error: 'GENERAL_ERROR' };
        }
      }
    },
    [dispatch, navigate],
  );

  const handleTabChange = useCallback(
    newTab => {
      dispatch(changeTab(newTab));
    },
    [dispatch],
  );

  const handleContinue = useCallback(async () => {
    const isFormValid = validateForm(formData, tab);

    if (!isFormValid) {
      return;
    }

    const result = await checkBudgetName(formData.name, params.id);
    return result;
  }, [formData, tab, validateForm, checkBudgetName, params.id]);

  return {
    tab,
    formData,
    isEditMode: params.id && !isNaN(params.id),
    handleTabChange,
    handleContinue,
  };
};
